<template>
  <div class="main">
    <AppHeader />
    <!--    header -->
    <main>
      <slot />
    </main>
    <AppFooter />
    <!--    footer -->
  </div>
</template>

<script lang="ts" src="./MainLayout.ts"></script>

<style lang="scss" scoped src="./MainLayout.scss"></style>
